import type { Crumb } from '@/components/ui/misc';
import { STAFF_NAV } from './staff';

const SEGMENT_LABELS: Record<string, string> = {
  new: 'New',
  edit: 'Edit',
  import: 'Import',
  export: 'Export',
  batch: 'Batch edit',
  staff: 'Staff',
  admin: 'Administration',
  tools: 'Tools',
  'design-system': 'Design system',
  'pull-list': 'Holds to pull',
  sql: 'SQL reports',
  login: 'Sign in',
};

const PATH_LABELS: Map<string, string> = new Map();
for (const group of STAFF_NAV) {
  for (const item of group.items) {
    item.children?.forEach((child) => PATH_LABELS.set(child.to.split('?')[0] as string, child.label));
    // Set last so the parent's name wins for a shared index path (/staff/patrons is "Patrons", not "All patrons").
    PATH_LABELS.set(item.to, item.label);
  }
}
// Parents whose index page is labelled differently from the nav entry.
PATH_LABELS.set('/staff', 'Dashboard');
PATH_LABELS.set('/staff/admin', 'Administration');
PATH_LABELS.set('/staff/tools', 'Tools');
PATH_LABELS.set('/staff/items', 'Items');
PATH_LABELS.set('/staff/catalog', 'Catalogue');
PATH_LABELS.set('/staff/catalog/authorities', 'Authorities');
PATH_LABELS.set('/staff/circulation/holds', 'Holds queue');

const isIdSegment = (segment: string): boolean => /^\d+$/.test(segment) || /^[0-9a-f]{8}-[0-9a-f-]{27,}$/i.test(segment);

/** Breadcrumb trail for a staff URL: "Staff > Catalogue > #42 > Edit". Dashboard itself has no trail. */
export function staffBreadcrumbs(pathname: string): Crumb[] {
  const segments = pathname.split('/').filter(Boolean);
  if (segments[0] !== 'staff' || segments.length === 1) {
    return [];
  }
  const crumbs: Crumb[] = [{ label: 'Staff', to: '/staff' }];
  let path = '';
  for (let i = 0; i < segments.length; i += 1) {
    const segment = segments[i] as string;
    path += `/${segment}`;
    if (i === 0) {
      continue;
    }
    const label = PATH_LABELS.get(path) ?? SEGMENT_LABELS[segment] ?? (isIdSegment(segment) ? `#${segment.length > 12 ? segment.slice(0, 8) : segment}` : segment.charAt(0).toUpperCase() + segment.slice(1).replace(/-/g, ' '));
    crumbs.push({ label, to: i === segments.length - 1 ? undefined : path });
  }
  return crumbs;
}
